<template>
  <div class="crud_module--select_contact">
    <div class="text" v-if="action == 'List'">
        
    </div>
    <div class="text" v-if="action == 'View'">
        {{display_name()}}
    </div>
    <div class="row" v-else>
      <div class="item">
        <div class="cps">
          <div class="cp_title">
            <input type="checkbox" :id="col+'-all'" v-model="select_all" @change="selectAll()">
            <label :for="col+'-all'" class="label">{{$t('label.all')}}</label>
          </div>
          <div class="cp_content">
            <div class="el-row" style="margin-left: -5px; margin-right: -5px;">
              <div class="cp el-col el-col-6" v-for="row in cps" :key="row[value]">
                <input type="checkbox" :id="col+'-'+row[value]" :value="row[value]" @change="selectOne()" v-model="select_cp">
                <label :for="col+'-'+row[value]" class="label">{{row[label]}}</label>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ["data","k","field","action"],
  async beforeMount() {
    this.label=this.field.label;
    this.value=this.field.value;
    this.col = this.field.key;
    this.get_option=this.field.get_option;
    this.get_data=this.field.get_data;
    this.id = this.$route.params.id;
    await this.init();
  },
  methods: {
    async init() {
      var _this = this;
      await this.$axios.get(`/${this.get_option}`, {
        params: {
          size: 99999,
          page: 0,
          trash: 0,
            enable_flag: 1
        }
      }).then(res=>{
        let data = res.data.response.dataset;
        console.log(_this.get_option,data);
        _this.cps = data.content;
        return true;
      }).catch(err=>{ return false; });
      if(this.id){
        await this.$axios.get(`/${this.get_data}/${this.id}`, {}).then(res=>{
          _this.select_cp = [];
          for(var i in res.data){
            var d = res.data[i];
            _this.select_cp.push(d[_this.value]);
          }
          _this.selectOne();
          // console.log(res.data);
          return true;
        }).catch(err=>{ return false; });
      }
    },
    selectAll(){
      var list = this.cps;
      var arr = [];
      if(this.select_all){
        for(var i in list){
          var cp = list[i];
          arr.push(cp[this.value]);
        }
      }
      this.select_cp = arr;
      this.$emit("input", this.select_cp);
    },
    selectOne(){
      var length = this.cps.length;
      var tlength = this.select_cp.length;
      if(length == tlength){
        this.select_all = true;
      }
      else {
        this.select_all = false;
      }
      this.$emit("input", this.select_cp);
    },
    display_name(){
      var arr1 = [];
      try {
        var _this = this;
        var da = this.cps.filter(row=>_this.select_cp.includes(row[_this.value]));
        for(var i in da){
          arr1.push(da[i][this.label]);
        }
      } catch (error) {
      }
      return arr1.join(',')
    }
  },
  computed:{
  },
  data() {
    return {
      col:"",
      label:"",
      value:"",
      get_option:"",
      get_data:"",
      cps:[],
      select_cp:[],
      id:0,
      select_all:false
    }
  }
}
</script>

<style lang="scss">
.crud_module--select_contact{
  width: 100%;
  .row{
    display: flex;
    margin-bottom: 20px;
    width: 100%;
    max-width: 100%;
    .item{
      flex-grow: 1;
      display: flex;
      width: 100%;
      font-size: x-small;
      // margin-right: 20px;
      .item__type--tab{
        flex-grow: 1;
        overflow-x: auto;
      }
      .data{
        width: 100%;
        display: flex;
      }
      .label{
        width: 130px;
        min-width: 130px;
        display: flex;
        align-items: center;
      }
      .value{
        min-width: 200px;
        width: 100%;
        > input{
          width: calc(100% - 10px);
          height: 25px;
          padding: 5px;
        }
        > select{
          width: 100%;
          height: 35px;
          padding: 5px;
        }
      }
      .cp_title{
        margin-bottom: 10px;
        font-size: small;
        background: #414e75;
        color: white;
        padding: 5px 10px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        label{
          display:inline-block;
        }
      }
      .cp{
        display: flex;
        padding-left: 5px; 
        padding-right: 5px;
      }
      .cps{
        border: 1px solid #e3e3e3;
        border-radius: 5px;
        box-shadow: 0px 1px 5px #ddd;
        display: flex;
        flex-direction: column;
        background: white;
        width: 100%;
      }
      .action{
        margin: 5px;
      }
    }
  }
}
</style>